// extracted by mini-css-extract-plugin
export default {"singleVideo":"SingleVideo_singleVideo__l+VK+","iFrame_container":"SingleVideo_iFrame_container__0yL4w"};